import { Grid, TextField, InputLabel } from '@mui/material';
import { Box } from '@mui/system';
import { IFormController } from '../types';

const TextArea = (props: IFormController) => {
  const { label, name, formik, placeholder, required, ...rest } = props;
  if (!formik) return <></>;
  return (
    <Grid>
      <Box>
        <InputLabel
          htmlFor={name}
          disabled={props.disabled}
          required={required}
          sx={{
            my: 2,
            textAlign: 'left',
            textStyle: 'none',
          }}
        >
          {label}
        </InputLabel>
        <TextField
          fullWidth
          multiline
          placeholder={placeholder}
          minRows={3}
          id={name}
          {...formik.getFieldProps(`${name}`)}
          {...rest}
        />
      </Box>
    </Grid>
  );
};
export default TextArea;